module.exports = __webpack_public_path__ + "static/vib_play4-3e7bb3adfa0d711fdd9411d101dfcbdf.jpg";